<template>
  <tr
    class="tw-border-b tw-border-t tw-border-neutral-200"
    :class="{ 'tw-select-none': isDisabled }"
  >
    <!--First column-->
    <td class="tw-min-w-[300px] tw-py-3 tw-pr-3">
      <div class="tw-flex tw-items-center tw-space-x-4">
        <a :href="mentee.personalUrl" target="_blank">
          <Avatar
            :src="mentee.avatarUrl"
            :alt="`${mentee.firstName} ${mentee.lastName}'s avatar`"
            size="lg"
            class="tw-shrink-0"
          />
        </a>
        <div class="tw-flex tw-flex-col tw-space-y-2">
          <div>
            <div class="tw-text-sm tw-font-semibold">
              <a
                :href="mentee.personalUrl"
                target="_blank"
                class="hover:tw-text-current"
              >
                {{ mentee.displayName }}
              </a>
            </div>
            <div class="tw-text-xs tw-font-medium tw-text-neutral-500">
              {{ position }}
            </div>
          </div>
        </div>
      </div>
    </td>

    <!--Second column-->
    <td class="tw-min-w-[250px] tw-py-3 tw-pr-3">
      <div
        class="tw-flex tw-items-center tw-py-3 tw-text-xs tw-text-neutral-500"
      >
        <LabelIcon class="tw-mr-3 tw-h-4 tw-w-4 tw-shrink-0" />
        <div>
          {{ mentee.lookingFors.length ? mentee.lookingFors.join(', ') : '-' }}
        </div>
      </div>
    </td>

    <!--Third column-->
    <td class="tw-min-w-[175px] tw-py-3 tw-pr-3 tw-text-xs tw-text-neutral-500">
      {{ mentee.country || '-' }}
    </td>

    <!--Fourth column-->
    <td class="tw-min-w-[175px] tw-py-3 tw-pr-3 tw-text-xs tw-text-neutral-500">
      {{ mentee.industries.length ? mentee.industries.join(', ') : '-' }}
    </td>

    <!--Fifth column-->
    <td class="tw-min-w-[150px] tw-py-3 tw-pr-3 tw-text-right">
      <BaseButton
        :href="mentee.personalUrl"
        color="outline-secondary"
        target="_blank"
        :is-disabled="isDisabled"
      >
        View Profile
      </BaseButton>
    </td>
  </tr>
</template>

<script setup>
import Avatar from '@/shared/components/avatar/Avatar.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import LabelIcon from '@/assets/images/icons/label.svg'
import { computed } from 'vue'

const props = defineProps({
  mentee: {
    type: Object,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

const position = computed(() => {
  if (props.mentee.professionTitle) {
    return `${props.mentee.professionTitle} ${
      props.mentee.companyName ? `at ${props.mentee.companyName}` : ''
    }`
  }
  return ''
})
</script>
